import { CheckIcon } from '@src/components/icons/CheckIcon';
import { classes } from '@src/components/layout/space';
import './SelectionCheck.css';

/** Decorative selected-state marker. Its control supplies aria-pressed/aria-selected. */
export function SelectionCheck({ className }: { className?: string }) {
  return (
    <span className={classes('selection-check', className)} aria-hidden="true">
      <CheckIcon />
    </span>
  );
}
